import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardTreeviewComponent } from 'dashboard-lib';

@Component({
  selector: 'app-dashboard-wrapper',
  standalone: true,
  imports: [CommonModule, DashboardTreeviewComponent],
  templateUrl: './dashboard-wrapper.component.html',
  styleUrls: ['./dashboard-wrapper.component.scss']
})
export class DashboardWrapperComponent {}
